// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__uNEXk","tooltip_icon":"Tooltip_tooltip_icon__H0IhT","screenReaderOnly":"Tooltip_screenReaderOnly__Eq5sS"};